/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Layout from '../../components/Layout';
import Page from '../../components/Page';
import about from './about.md';

function action() {
	return {
		chunks: ['about'],
		title: about.title,
		description:
			'New Tab Studio is a browser extension that replaces the new tab page with a dashboard you build yourself. Who makes it, how it works and what it stores.',
		component: (
			<Layout>
				<Page {...about} />
			</Layout>
		),
	};
}

export default action;
